import { GetChannelConfigFunction } from '@root/libs/init-channel/types';
import { Data, DataComments } from '@root/modules/article/types/article';
import { Route } from 'vue-router';
import { mergeAdsPlacements } from '@ads/utils/mergeAdsPlacements';

export default function getArticleAdsSettings({
  $channelConfig,
  $route,
  article,
}: {
  $channelConfig: GetChannelConfigFunction;
  $route: Route;
  article: Data | DataComments;
}) {
  const { id } = $channelConfig('settings');
  const { adForm } = $channelConfig('ads').component;

  const keyValue = [`www.delfi.lt:${id === 'delfi' ? 'front' : id}`];

  // Create keywords data
  const keywords = [`${id}`, `${article.id}`, `${article.primaryCategory.slug}`];

  // Add parent category slug
  const parentCategory = article.primaryCategory.parentCategory || null;
  if (parentCategory && parentCategory.id && parentCategory.id.toString() !== $channelConfig('settings').externalId) {
    const parentSlug = parentCategory.slug;
    keywords.push(parentSlug);
  }

  if (article.tags.items) {
    article.tags.items.forEach(tag => {
      keywords.push(`ck-${tag.slug}`);
    });
  }

  if (article.content.paywall.enabled) {
    keywords.push(`paid_article`);
  }

  // Get page placements
  const { component } = $channelConfig('page').category;
  const channelId = $channelConfig('settings').id;
  const categorySlug = $route.params.category && $route.params.category !== channelId ? $route.params.category : $route.params.subcategory;
  const channelAdsConfig = component?.adForm?.filter(ad => ad.categories.includes(categorySlug)) || [];
  const channelPlacements: Record<string, unknown> = adForm.placements || {};
  const placements = channelAdsConfig[0]?.placements ? mergeAdsPlacements(channelPlacements, channelAdsConfig[0]?.placements) : channelPlacements;
  const disableAds = $channelConfig('page').article.component?.adForm?.disableAds || adForm.disableAds;
  const enableAds = $channelConfig('page').article.component?.adForm?.enableAds || [];

  return {
    mkw: keywords,
    mkv: keyValue,
    placements,
    disableAds,
    enableAds,
    uniqueKey: [`${id}_${article.primaryCategory.slug}`],
  };
}
